import {Component, OnInit} from '@angular/core';
import {BcGqlService, IGQLForm} from "@betterchains/bc-gql";
import {TableModule} from 'primeng/table';
import {HttpErrorResponse, HttpResponse} from '@angular/common/http';
import {RouterLink} from '@angular/router';
import {Paginator, PaginatorState} from 'primeng/paginator';
import {Tag} from 'primeng/tag';
import {Button} from 'primeng/button';
import {AppDialogService} from './services/AppDialogService';

@Component({
  selector: 'forms-builder-index',
  templateUrl: './index.component.html',
  imports: [TableModule, RouterLink, Paginator, Tag, Button],
})
export class FormsBuilderIndexComponent implements OnInit {

  public data: IGQLForm[] = []

  first = 0;
  rows = 10;
  totalRecords = 0;

  public adminLevel = true;
  loading = true;

  constructor(
    private gql: BcGqlService,
    private dialogs: AppDialogService
  ) {
  }

  ngOnInit(): void {
    this.load();
  }

  public load() {
    this.adminLevel = true;
    let approversAndPositions = ""
    let chains = ""
    if (!this.adminLevel) {
      approversAndPositions = `
                approvers {
                  id
                  email
                  first_name
                  last_name
                }
                positions {
                  id
                  name
                }
    `
    } else {
      chains = `
      chains {
        chain_id
        name
      }
      `
    }
    this.loading = true;
    this.gql.query(
      // language=gql
      `
        query formsManageIndex($limit: Int, $offset: Int, $sort: String, $filter:[GridFilter]) {
          forms {
            forms(limit: $limit, offset: $offset, sort: $sort, filter: $filter){
              id
              form_name
              form_type
              description
              ${approversAndPositions}
              ${chains}
            }
          }
        }
      `,
      {
        limit: this.rows,
        offset: this.first
      }
    ).subscribe({
      next: (r: HttpResponse<{ data: { forms: { forms: IGQLForm[] } } }>) => {

        this.totalRecords = Number(r.headers.get('x-pagination-total-count'));

        this.loading = false;
        if (r.body) {
          this.data = r.body.data.forms.forms
        } else {
          this.dialogs.Alert("Error", "Something went wrong. Please try to refresh the page.")
        }
      },
      error: (e:HttpErrorResponse) => {
        this.dialogs.Alert("Error", e.message)
        this.loading = false;
      }
    })
  }


  onPageChange($event: PaginatorState) {
    this.first = $event.first;
    this.rows = $event.rows;
    this.load();
  }
}
